import { MfsQuery } from './mfsQuery';
import { isPositiveInteger } from '../../utility';
import { mfsError } from '../../errors/storeErrors';

/** Validates the given `MfsQuery` object */
export function throwIfInvalidQuery(query?: MfsQuery): void {
  if (!query) return;

  function throwIfInvalid(x: number, name: string): void {
    if (!isPositiveInteger(x)) {
      throw mfsError.mustBePositiveInteger(name);
    }
  }

  if (
    query.top !== undefined ||
    query.skip !== undefined ||
    query.filter !== undefined ||
    query.select !== undefined ||
    query.orderBy !== undefined
  ) {
    if (query.top !== undefined) {
      throwIfInvalid(query.top, 'top');
    }

    if (query.skip !== undefined) {
      throwIfInvalid(query.skip, 'skip');
    }

    if (query.select && !query.select.some((p) => !!p)) {
      throw mfsError.emptySelectQuery();
    }
  } else {
    throw mfsError.emptyMfsQuery();
  }
}
